import { AxiosError } from "axios"

import { queryClient } from "~/backend/queryClient"
import {
  findContactrMappingQueryKey,
  useCreateContactByEmail,
} from "~/gen/api/hooks"
import { showAxiosError } from "~/utils/showAxiosError"

export const useCreateContactByEmailMutation = ({
  searchSupplier,
}: {
  searchSupplier: string
}) =>
  useCreateContactByEmail({
    mutation: {
      onSuccess: async (data) => {
        if (data) {
          queryClient.invalidateQueries({
            queryKey: findContactrMappingQueryKey({
              searchSupplier,
            }),
            refetchType: "all",
          })
        }
      },
      onError: (error) => {
        if (error instanceof AxiosError) {
          showAxiosError({
            notificationTitle: "Supplier create error",
            notificationMessage:
              "Supplier create failed : " + error.response?.data?.message,
            showNotification: true,
            error,
          })
        }
      },
    },
  })
